/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getIntraOPNursingRecords } from 'app/entities/intra-op-nursing-record/intra-op-nursing-record.reducer';
import { PackType } from 'app/shared/model/enumerations/pack-type.model';
import { createEntity, getEntity, reset, updateEntity } from './intra-op-pack.reducer';

export const IntraOPPackUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const intraOPNursingRecords = useAppSelector(state => state.intraOPNursingRecord.entities);
  const intraOPPackEntity = useAppSelector(state => state.intraOPPack.entity);
  const loading = useAppSelector(state => state.intraOPPack.loading);
  const updating = useAppSelector(state => state.intraOPPack.updating);
  const updateSuccess = useAppSelector(state => state.intraOPPack.updateSuccess);
  const packTypeValues = Object.keys(PackType);

  const handleClose = () => {
    navigate(`/intra-op-pack${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getIntraOPNursingRecords({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...intraOPPackEntity,
      ...values,
      nursingRecord: intraOPNursingRecords.find(it => it.id.toString() === values.nursingRecord?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          packType: 'PACKING',
          ...intraOPPackEntity,
          nursingRecord: intraOPPackEntity?.nursingRecord?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.intraOPPack.home.createOrEditLabel" data-cy="IntraOPPackCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.intraOPPack.home.createOrEditLabel">Create or edit a IntraOPPack</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="intra-op-pack-id"
                  label={translate('tinyMedicRestApp.intraOPPack.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPPack.packType')}
                id="intra-op-pack-packType"
                name="packType"
                data-cy="packType"
                type="select"
              >
                {packTypeValues.map(packType => (
                  <option value={packType} key={packType}>
                    {translate(`tinyMedicRestApp.PackType.${packType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPPack.tmSize')}
                id="intra-op-pack-tmSize"
                name="tmSize"
                data-cy="tmSize"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPPack.site')}
                id="intra-op-pack-site"
                name="site"
                data-cy="site"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPPack.amount')}
                id="intra-op-pack-amount"
                name="amount"
                data-cy="amount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPPack.active')}
                id="intra-op-pack-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPPack.cursor')}
                id="intra-op-pack-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPPack.lastupdated')}
                id="intra-op-pack-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPPack.microSec')}
                id="intra-op-pack-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPPack.timestampentry')}
                id="intra-op-pack-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="intra-op-pack-nursingRecord"
                name="nursingRecord"
                data-cy="nursingRecord"
                label={translate('tinyMedicRestApp.intraOPPack.nursingRecord')}
                type="select"
                required
              >
                <option value="" key="0" />
                {intraOPNursingRecords
                  ? intraOPNursingRecords.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/intra-op-pack" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default IntraOPPackUpdate;
